import moment from "moment";
import NumeroALetras from "../../../../componentes/funciones/NumeroALetras";
import { NegocioConfig } from "../../../../configuracion/Empresa";
import { formatoMoneda } from "../../../../configuracion/validaciones";
import { ImprimirEnIframe } from "../../../../componentes/imprimir/ImprimirEnIframe";
import { generarPDF } from "../../../../componentes/imprimir/GenerarPDF";

export const ImprimirApertura = (apertura, usuario) => {
    if (!apertura) return;

    const {
        fechaApertura,
        efectivo = 0,
        id,
    } = apertura;

    const codigoApertura = id ? `CA-${String(id).padStart(5, "0")}` : "—";
    const empleadoNombre = usuario?.datoPersonales?.nombreCorto || "—";
    const usuarioId = usuario?.datoPersonales?.id || "—";
    const fechaHora = moment(fechaApertura || new Date()).format("DD-MM-YYYY HH:mm:ss");
    const logoSrc = NegocioConfig.logo;


    const html = `
        <div style="width:280px; font-family:'Arial', sans-serif; font-size:14px; color:black; padding:0; margin:0;">
            <img src="${logoSrc}" style="width:100px; height:100px; display:block; margin:0 auto;" alt="Logo" />
            <div style="text-align:center; margin-bottom:5px;">
                <div style="font-weight:bold; font-size:16px;">${NegocioConfig.nombre}</div>
                <div style="font-size:12px;">RTN: ${NegocioConfig.rtn}</div>
                <div style="font-size:12px;">${NegocioConfig.direccion}</div>
                <div style="font-size:12px;">Tel: ${NegocioConfig.telefono}</div>
            </div>

            <hr style="border:1px dashed black; margin: 5px 0;" />

            <div style="font-weight:bold; margin:5px 0; text-align: left; font-size:15px;">APERTURA DE CAJA No. ${codigoApertura}</div>
            <div style="text-align: left;"><span>Fecha:</span> ${fechaHora}</div>
            <div style="text-align: left;"><span>Responsable:</span> ${empleadoNombre}</div>
            <div style="text-align: left;"><span>ID Usuario:</span> ${usuarioId}</div>

            <hr style="border:1px dashed black; margin: 5px 0;" />

            <div style="margin:10px 0; font-size:13px;">
                <div style="font-weight:bold; text-align:center; margin-bottom:6px; background-color:#f0f0f0; padding:3px;">MONTO INICIAL (EFECTIVO)</div>
                <table style="width:100%; border-collapse:collapse;">
                    <tr>
                        <td style="padding:2px 0;">EFECTIVO:</td>
                        <td style="text-align:right; padding:2px 0; font-weight:bold;">${formatoMoneda(efectivo)}</td>
                    </tr>
                </table>
            </div>

            <hr style="border:2px solid black; margin: 10px 0;" />
    
            <div style="margin-top:8px; font-size:12px; text-transform:uppercase; text-align: left; font-weight:500;">
                ${NumeroALetras(efectivo)}
            </div>
            <div style="font-size:14px; font-weight:bold; text-align: right; background-color: #dddddd; padding: 5px;">TOTAL EN CAJA: ${formatoMoneda(efectivo)}</div>
    
            <div style="text-align:center; margin-top:20px; font-size:14px;">
                <strong>¡Apertura generada exitosamente!</strong>
            </div>
        </div>
        `;

    ImprimirEnIframe(html, `Apertura de Caja ${codigoApertura}`, '5px');
    const nombrePDF = `Comprobante_Apertura_${codigoApertura}.pdf`;
    generarPDF(html, nombrePDF, 88);
};